<template>
    <div>
        <div>
            <div class="form-group">
                <el-select
                    v-model="choice"
                    :class="`wp-10`"
                    filterable
                    :multiple="filter.inputs.choice.multiple"
                >
                    <el-option
                        v-for="option in filter.inputs.choice.options"
                        :key="'opt-' + option.value"
                        :label="option.label"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            choice: '',
        };
    },
    computed: {
        data() {
            return {
                choice: this.choice,
            };
        },
    },
};
</script>
